import { Backdrop as StyledBackdrop } from './Backdrop.styled';
import { BackdropProps } from './index';

export const Backdrop = ({ ...props }: BackdropProps) => <StyledBackdrop {...props} />;

export default Backdrop;
